import { useRef } from 'react';
import { Box, Button, Paper } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDownloadExcel } from 'react-export-table-to-excel';
import { getStoredCompanyDetails, getCompanyDisplayFromDetails, getShortCompanyName } from '../../services/companyService';

const SeperationReport = () => {
    const CombinedSalarayTableRef = useRef(null);
    const location = useLocation();
    const companyDetails = useSelector((state) => state.auth.activeCompanyDetails) || getStoredCompanyDetails();
    const { companyName } = getCompanyDisplayFromDetails(companyDetails || {});
    const {seperationRateDetails} = location.state;
    const {fromDate, toDate} = location.state.duration;
    const seperationPercentage = ( ((seperationRateDetails.employeesLeft*100)/
                                (seperationRateDetails.openingBalance + 
                                seperationRateDetails.closingBalance + 
                                seperationRateDetails.employeesJoined + 
                                seperationRateDetails.employeesLeft))/100 ).toFixed(2);

    // Extract month and year from fromDate (assuming format like "2024-01-01" or "01-01-2024")
    const getMonthYearFromDate = (dateStr) => {
        if (!dateStr) return { month: '', year: '' };
        const date = new Date(dateStr);
        const monthNames = ["January", "February", "March", "April", "May", "June", 
                           "July", "August", "September", "October", "November", "December"];
        return {
            month: monthNames[date.getMonth()],
            year: date.getFullYear().toString()
        };
    };
    
    const { month, year } = getMonthYearFromDate(fromDate);
    
    const { onDownload } = useDownloadExcel({
        currentTableRef: CombinedSalarayTableRef.current,
        filename : `${getShortCompanyName(companyName) || 'Report'} Report for Separation Rate ${month.substring(0, 3)} ${year}`,
        sheet : "sheet"
    })

    return (
        <Box sx={{display: "flex" ,justifyContent: "center", padding: "10px", fontWeight: "500px"}}>

        <Paper elevation={0} sx={{width: "1500px", padding: '50px'}}>
            <Button 
                variant='contained'
                color='success'
                onClick={ onDownload }
            >
                Download Seperation Rate Report (excel)
            </Button>

            <table 
                class="table"
                ref={ CombinedSalarayTableRef }
                style = {{
                    marginTop: '10px',
                    border: '1px solid #999',
                    borderCollapse: 'collapse',
                    width: 'auto',
                    tableLayout: 'auto'
                }}
            >
        <colgroup>
            <col style={{ width: 'auto', minWidth: '200px' }} />
            <col style={{ width: 'auto', minWidth: '150px' }} />
            <col style={{ width: 'auto', minWidth: '180px' }} />
            <col style={{ width: 'auto', minWidth: '150px' }} />
            <col style={{ width: 'auto', minWidth: '150px' }} />
            <col style={{ width: 'auto', minWidth: '120px' }} />
        </colgroup>
        <thead class="table-dark">
            <tr>
                <th colSpan={6} style={{textAlign: 'center', border: '1px solid #999', padding: '8px'}}>Separation Rate details for {month} {year}</th>
            </tr>
            <tr>      
                <th style={{ border: '1px solid #999', padding: '8px' }}>Duration</th>     
                <th scope="col" style={{ border: '1px solid #999', padding: '8px', textAlign: 'right' }}>Opening Balance</th>
                <th scope="col" style={{ border: '1px solid #999', padding: '8px', textAlign: 'right' }}>No of Employees Joined</th>
                <th scope="col" style={{ border: '1px solid #999', padding: '8px', textAlign: 'right' }}>Employees Left</th>
                <th scope="col" style={{ border: '1px solid #999', padding: '8px', textAlign: 'right' }}>Closing Balance</th>
                <th scope="col" style={{ border: '1px solid #999', padding: '8px', textAlign: 'right' }}>Seperation %</th>
            </tr>
        </thead>
        <tbody>
            <tr align="right">   
                <td style={{ border: '1px solid #999', padding: '8px', textAlign: 'left' }}>{fromDate} - {toDate}</td>
                <td style={{ border: '1px solid #999', padding: '8px', textAlign: 'right' }}>{seperationRateDetails.openingBalance}</td>
                <td style={{ border: '1px solid #999', padding: '8px', textAlign: 'right' }}>{seperationRateDetails.employeesJoined}</td>
                <td style={{ border: '1px solid #999', padding: '8px', textAlign: 'right' }}>{seperationRateDetails.employeesLeft}</td>
                <td style={{ border: '1px solid #999', padding: '8px', textAlign: 'right' }}>{seperationRateDetails.closingBalance}</td>
                <td style={{ border: '1px solid #999', padding: '8px', textAlign: 'right' }}>{seperationPercentage}%</td>
            </tr>
        </tbody>
      </table>
            </Paper>

        </Box>
    );
}

export default SeperationReport;
